import { dowloadDocument } from "../services/api/data/document";
import DocumentFile from "./Document";

export default class MapModel extends DocumentFile {
  static url = "maps";

  download() {
    const params = new URLSearchParams();
    dowloadDocument(`${MapModel.url}/${this.id}/download/`, `${this.name}.jpeg`);
  }
}
